import React, { useState } from "react";
import Badge from '@mui/material/Badge';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { ThemeProvider } from '@mui/material/styles';
import theme from './colors/theme';
import { createTheme } from "@mui/material";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/molecules/popover";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog"
import { Label } from './texts/label';
// import useNotifications from '@/hooks/global-hooks/useNotification';
import Notification from '../organisms/notification/Notification';
import { Button } from '../molecules/buttons/button';
import { useNavigate } from "react-router-dom";
import { useAuthContext } from '@/context/AuthContext';
import { useNotifications } from "@/hooks/global-hooks/NotificationContext";
// import { useNotifications } from "@/hooks/global-hooks/NotificationContext";

function NotificationIcon({ isForMobile = false, componentForMobile, className, ...props }) {
    // const { notifications, error } = useNotifications();
    const { notifications,
        informations,
        actions,
        readNotification,
        deleteNotification,
        markAllAsRead,
        sortNotifications,
        loading,
        error,
        refetch } = useNotifications();

    const { hasPrivileges, isBrowsingAllowedTo } = useAuthContext();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    // console.log("user = ", user, hasPrivileges("ADMIN_"))
    const handleClick = () => {
        setIsOpen(false);

        isBrowsingAllowedTo("/consultant") && navigate("/consultant");
    }

    if (error || (!notifications)) {
        // Log seulement une fois pour éviter les boucles infinies
        if (error && !window.__notificationErrorLogged) {
            console.error("error notff icon ", error);
            window.__notificationErrorLogged = true;
            // Reset après 10 secondes pour permettre de relogger si le problème persiste
            setTimeout(() => { window.__notificationErrorLogged = false; }, 10000);
        }
        return <Popover onOpenChange={setIsOpen} open={isOpen} props>
            <PopoverTrigger className={`mr-3 ${isForMobile && `w-full`}` }>
                {isForMobile ? componentForMobile :
                    <Badge color="pink" size="small" badgeContent={"!"}>

                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                            <path d="M12.9993 20H8.99932M1.29316 4.81989C1.27882 3.36854 2.0613 2.01325 3.32538 1.3M20.7015 4.8199C20.7159 3.36855 19.9334 2.01325 18.6693 1.3M16.9993 7C16.9993 5.4087 16.3672 3.88258 15.242 2.75736C14.1167 1.63214 12.5906 1 10.9993 1C9.40802 1 7.8819 1.63214 6.75668 2.75736C5.63146 3.88258 4.99932 5.4087 4.99932 7C4.99932 10.0902 4.21979 12.206 3.34899 13.6054C2.61445 14.7859 2.24718 15.3761 2.26065 15.5408C2.27556 15.7231 2.31418 15.7926 2.4611 15.9016C2.59378 16 3.19191 16 4.38818 16H17.6105C18.8067 16 19.4049 16 19.5375 15.9016C19.6845 15.7926 19.7231 15.7231 19.738 15.5408C19.7515 15.3761 19.3842 14.7859 18.6497 13.6054C17.7789 12.206 16.9993 10.0902 16.9993 7Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Badge>}


            </PopoverTrigger>
            <PopoverContent className="flex flex-col max-h-[300px] gap-secondDegree w-96 bg-error py-paddingTopAndBottom px-paddingLeftAndRight">
                <Label size='bodySmall' fontWeight="bold" message='error.fetchUnsuccessfull'>error</Label>


            </PopoverContent>
        </Popover>;
    }
    const unreadNotificationsCount = notifications?.filter(notification => notification.readStatus === 'UNREAD').length;

    return (
        isForMobile ?
            <div>
                <Dialog onOpenChange={setIsOpen} open={isOpen} modal className={isForMobile && `w-full`}>
                    <DialogTrigger asChild onClick={() => { setIsOpen(true); console.log("trigger activation") }} className={isForMobile && `w-full`}
                    >
                        {componentForMobile}
                    </DialogTrigger>
                    <DialogContent className="sm:max-w-[725px] gap-thirdDegree  " xClose={true} >
                        <div className='max-w-full overflow-auto space-y-firstDegree max-h-[300px] '>
                            {notifications.map((notification, index) => (
                                <Notification key={index} notification={notification} showDate={false} />
                            ))}
                        </div>
                        {hasPrivileges("ADMIN_") &&
                            <Button style="ghost" className="font-bold" onClick={handleClick} text="global.actions.showMore"></Button>
                        }
                    </DialogContent>


                </Dialog>
            </div >
            : <Popover onOpenChange={setIsOpen} open={isOpen}>
                <PopoverTrigger className="mr-3">

                    <Badge color="pink" size="small" badgeContent={unreadNotificationsCount}>

                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                            <path d="M12.9993 20H8.99932M1.29316 4.81989C1.27882 3.36854 2.0613 2.01325 3.32538 1.3M20.7015 4.8199C20.7159 3.36855 19.9334 2.01325 18.6693 1.3M16.9993 7C16.9993 5.4087 16.3672 3.88258 15.242 2.75736C14.1167 1.63214 12.5906 1 10.9993 1C9.40802 1 7.8819 1.63214 6.75668 2.75736C5.63146 3.88258 4.99932 5.4087 4.99932 7C4.99932 10.0902 4.21979 12.206 3.34899 13.6054C2.61445 14.7859 2.24718 15.3761 2.26065 15.5408C2.27556 15.7231 2.31418 15.7926 2.4611 15.9016C2.59378 16 3.19191 16 4.38818 16H17.6105C18.8067 16 19.4049 16 19.5375 15.9016C19.6845 15.7926 19.7231 15.7231 19.738 15.5408C19.7515 15.3761 19.3842 14.7859 18.6497 13.6054C17.7789 12.206 16.9993 10.0902 16.9993 7Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Badge>

                </PopoverTrigger>
                <PopoverContent className="flex flex-col max-h-[300px] gap-secondDegree w-96 bg-white py-paddingTopAndBottom px-paddingLeftAndRight">
                    <div className='max-w-full overflow-auto space-y-firstDegree '>
                        {notifications.map((notification, index) => (
                            <Notification key={index} notification={notification} showDate={false} />
                        ))}
                    </div>
                    {hasPrivileges("ADMIN_") &&
                        <Button style="ghost" className="font-bold" onClick={handleClick} text="global.actions.showMore"></Button>
                    }
                </PopoverContent>
            </Popover>
    )
}

export default NotificationIcon;
